/**
 * GL214-7 (glasronde 0.9.214, Frank 28 oktober 2026): in de lijst Agenten was niet te zien dat een
 * agent een vast tijdstip heeft. Kort, zoals Frank het schreef: "ma 09:00", "ma-vr 08:30",
 * "ma, wo 09:00". Geen tijdstip: een lege tekst, en dan staat er niets. PUUR.
 */
const KORT = {
  nl: ["ma", "di", "wo", "do", "vr", "za", "zo"],
  en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
};

export function kortTijdstip(tijdstip, taal = "nl") {
  const dagen = [...new Set((tijdstip?.dagen || []).filter((d) => Number.isInteger(d) && d >= 0 && d <= 6))].sort((a, b) => a - b);
  if (!dagen.length) return "";
  const namen = KORT[taal === "en" ? "en" : "nl"];
  const uur = `${String(tijdstip.uur ?? 0).padStart(2, "0")}:${String(tijdstip.minuut ?? 0).padStart(2, "0")}`;
  const werkdagen = dagen.join() === "0,1,2,3,4";
  const alle = dagen.length === 7;
  const deel = alle ? (taal === "en" ? "daily" : "dagelijks") : werkdagen ? `${namen[0]}-${namen[4]}` : dagen.map((d) => namen[d]).join(", ");
  return `${deel} ${uur}`;
}
